// Automatic check numbers: 6-digit, newest stub highest, 30-80 apart per pay period.
const hash = (a, b) => {
  let h = (Math.imul(a >>> 0, 2654435761) ^ Math.imul(b + 1, 40503)) >>> 0;
  h ^= h >>> 13;
  h = Math.imul(h, 2246822519) >>> 0;
  h ^= h >>> 16;
  return h >>> 0;
};

export const checkGap = (seed, i) => 30 + (hash(seed, i) % 51);

export const randomCheckStart = () => 500000 + Math.floor(Math.random() * 400000);

export const seededCheckStart = (seedText) => {
  const n = String(seedText || '').split('').reduce((t, c) => (Math.imul(t, 31) + c.charCodeAt(0)) >>> 0, 7);
  return 500000 + (hash(n, 0) % 400000);
};

export const isValidCheckNumber = (v) => /^\d{6,}$/.test(String(v ?? '').trim());

// index 0 = newest (highest); each older stub is 30-80 lower.
export const descendingCheckNumbers = (count, latest = randomCheckStart()) => {
  const out = [];
  let n = latest;
  for (let i = 0; i < count; i++) {
    out.push(String(n));
    n -= checkGap(latest, i);
  }
  return out;
};

// Check number k pay periods after (k>0) or before (k<0) `base`.
export const shiftCheckNumber = (base, k) => {
  let n = base;
  for (let j = 0; j < Math.abs(k); j++) n += (k > 0 ? 1 : -1) * checkGap(base, (k > 0 ? 1000 : 2000) + j);
  return n;
};

// Existing stubs need renumbering if any number is short/missing or the order is wrong.
export const needsCheckRenumber = (stubs = []) =>
  stubs.some((s) => !isValidCheckNumber(s.checkNumber)) ||
  stubs.some((s, i) => i > 0 && Number(s.checkNumber) >= Number(stubs[i - 1].checkNumber));

// Per-company counter (backend) — keeps numbers unique across a company's employees.
const API = process.env.REACT_APP_BACKEND_URL;
const postJson = (path, body) => fetch(`${API}${path}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
}).then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.statusText))));

export const reserveCheckNumbers = (companyName, count) =>
  postJson('/api/check-numbers/reserve', { company_name: companyName, count }).then((d) => d.numbers);

export const peekCheckCounter = (companyName) =>
  fetch(`${API}/api/check-numbers/peek?company_name=${encodeURIComponent(companyName)}`)
    .then((r) => r.json()).then((d) => Number(d.last) || 0);

export const commitCheckNumbers = (companyName, numbers) =>
  postJson('/api/check-numbers/commit', { company_name: companyName, numbers: numbers.map(String) });
